import { useState, useEffect } from 'react';
import '../css/Carousel.css';
import FloatingStar from "../components/FloatingStart";


const Carousel = ({
  slides = [
    { image: "TESTDEMO/EmsExpoWebsite.webp" },
    { image: "FLOWMETER/IMG_6299-Photoroom.png", description: "Flowmeter" },
    { image: "TESTDEMO/P-DR813.png", description: "In-Gage Regulator" },
    { image: "TESTDEMO/masscass-no-bg.png", description: "Mass Causality System" },
    { image: "TESTDEMO/P-DR510-pressure-reduce-no-bg.png", description: "Pressure Reducer" },
    { image: "TESTDEMO/RR813.png", description: "RW Regulator" },
    { image: "TESTDEMO/tanks-Photoroom.png", description: "Gas Supply Systems" },
  ],
  autoSlide = false,
  slideInterval = 35000,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (autoSlide && slides.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
      }, slideInterval);
      return () => clearInterval(interval);
    }
  }, [autoSlide, slideInterval, slides.length]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="carousel-container">
      <button className="carousel-arrow left" onClick={prevSlide} aria-label="Previous Slide">
        &#10094;
      </button>

      <div className="carousel">
        <div className="carousel-glow-overlay"></div>
        <div className="carousel-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {slides.map(({ image, description }, index) => (
            <div className="carousel-slide" key={index}>
              <div className="carousel-slide-content">
                <img src={image} alt={`Slide ${index + 1}`} loading="eager" />
                {index === 0 && <FloatingStar />}
                {description && <p className="carousel-description">{description}</p>}
              </div>
            </div>
          ))}
        </div>


        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator-box ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>

      <button className="carousel-arrow right" onClick={nextSlide} aria-label="Next Slide">
        &#10095;
      </button>
    </div>
  );
};

export default Carousel;
